 import { Logger } from '@nestjs/common';
 import { NestFactory } from '@nestjs/core';
 import { SwaggerModule, DocumentBuilder } from '@nestjs/swagger';
 import { AppModule } from './app/app.module';
 import {appSettings} from '../../config';
//  import * as session from 'express-session';
 import * as passport from 'passport';
import { getRepository } from 'typeorm';
// import { TypeORMSession } from './app/auth/session';
// import { TypeormStore } from 'connect-typeorm/out';
 async function bootstrap() {
   const app = await NestFactory.create(AppModule);
  //  const sessionRepo = getRepository(TypeORMSession);
   app.enableCors();
  
  //  app.use(
  //    session({
  //      cookie:{
  //        maxAge:86400000,
  //      },
  //      secret:'asdfghjklasdfghjkl',
  //      resave: false,
  //      saveUninitialized:false,
  //      store : new TypeormStore().connect(sessionRepo)
  //    }),
  //  );

  //  app.use(passport.initialize());
  //  app.use(passport.session());

   const globalPrefix = 'erpx';
   app.setGlobalPrefix(globalPrefix);
   const port =  appSettings.ums_port;
   const options = new DocumentBuilder()
     .setTitle('ERPX')
     .setDescription('ERP X')
     .setVersion('1.0')
     .addTag('')
     .addBearerAuth()
     .build();
   const document = SwaggerModule.createDocument(app, options);
   SwaggerModule.setup('erpx', app, document);
   // await app.listen(3000);
   await app.listen(port, () => {
     Logger.log('Listening at http://localhost:' + port + '/' + globalPrefix);
   });
 }
 bootstrap();
 
